module.exports = __webpack_public_path__ + "img/00042.e10c8c5e.webp";